export const SECTION_IDS = {
  top: "top",
  howItWorks: "how-it-works",
  benefits: "benefits",
  whyGuardian: "why-guardian",
  pricing: "pricing",
  contact: "contact",
};

export const NAV_ITEMS = [
  { id: SECTION_IDS.howItWorks, label: "Cómo funciona" },
  { id: SECTION_IDS.benefits, label: "Beneficios" },
  { id: SECTION_IDS.whyGuardian, label: "Por qué Guardian+" },
  { id: SECTION_IDS.pricing, label: "Precios" },
  { id: SECTION_IDS.contact, label: "Contacto" },
];
